import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TreeModule } from '@ali-hm/angular-tree-component';
import { TranslateModule } from '@ngx-translate/core';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { TreeDropdownComponent } from './tree-dropdown.component';

@NgModule({
  declarations: [TreeDropdownComponent],
  imports: [
    CommonModule,
    NgClickOutsideDirective,
    TranslateModule,
    TreeModule,
  ],
  exports: [TreeDropdownComponent],
})
export class TreeDropdownModule {}
